import styles from "./CartButton.module.css";
import React, { useState } from "react";
import { FaCartShopping } from "react-icons/fa6";
import { useCartContext } from "../../../context/CartProvider";
import { CartModal } from "../../Modal/CartModal/CartModal";
import PastilleIcon from "../../CssIcon/PastilleIcon/PastilleIcon";
import { useTranslation } from "react-i18next";
import sidebarStyles from "../../Sidebar/Sidebar.module.css";
import { NavLink } from "react-router-dom";

export const CartButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { items } = useCartContext();
  const { t } = useTranslation();

  return (
    <>
      <CartModal isOpen={isOpen} handleClose={() => setIsOpen(false)} />

      <NavLink
        className={sidebarStyles.navLink}
        to="#"
        onClick={() => setIsOpen(true)}
      >
        <div className={styles.iconWrapper}>
          <FaCartShopping />
        </div>
        <div className={styles.label}>{t("cart.label")}</div>

        <div className={styles.pastilleContainer}>
          {items.length > 0 && <PastilleIcon>{items.length} </PastilleIcon>}
        </div>
      </NavLink>
    </>
  );
};
